import React from "react";
import DocumentSigner from "../components/DocumentSigner";
import Layout from "../components/layout/Esign";
import { Box, Typography } from "@mui/material";

const Esign = () => {
  return (
    <Layout>
      <Box sx={{ p: 4 }}>
        <Typography variant="h4" gutterBottom>
          Document E-Signature
        </Typography>
        <DocumentSigner />
      </Box>
    </Layout>
  );
};

export default Esign;
